import * as React from "react";
const SvgIcBatteryEmpty = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M4 8H18V16H4V8ZM21 9V5H1V19H21V15H23V9H21Z" fill="currentColor" /></svg>;
export default SvgIcBatteryEmpty;